module.exports = __webpack_public_path__ + "static/media/propic-10a.3dbc26a4.png";